import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import InfoIcon from '@mui/icons-material/Info';

const drawerWidth = 240;

const StyledDrawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    background: '#262626',
    color: '#fff',
  },
  '& .MuiListItemIcon-root': {
    color: '#fff',
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

interface AppDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function AppDrawer({ open, setOpen }: AppDrawerProps) {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    setOpen(false);
    navigate(path);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <StyledDrawer
      variant="temporary"
      anchor="left"
      open={open}
      onClose={handleDrawerClose}
    >
      <DrawerHeader />
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleNavigation('/')}>
            <ListItemIcon><AccountBoxIcon /></ListItemIcon>
            <ListItemText primary="maker" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleNavigation('/about')}>
            <ListItemIcon><InfoIcon /></ListItemIcon>
            <ListItemText primary="about" />
          </ListItemButton>
        </ListItem>
      </List>
    </StyledDrawer>
  );
}
